import { builder } from 'common/js/configs';
import { units } from 'common/js/configs/constants';

export const commonBlurEffect = {
  blurEffect: builder.holder({
    show: builder.boolean('blur_effect_show', {
      defaultValue: true,
      l:'',
      d:''
    }),

    image: builder.string('blur_effect_image', {
      overrideType: 'image',
      l:'',
      d:'',
      optional: true,
      if: 'blur_effect_show'
    }),

    force: builder.boolean('blur_effect_force', {
      l:'',
      d:'',
      defaultValue: false,
      if: 'blur_effect_show'
    }),

    zoom: builder.number('blur_effect_zoom', {
      defaultValue: 0,
      l:'',
      d:'',
      if: 'blur_effect_show'
    }),

    offsetX: builder.number('blur_effect_offsetX', {
      defaultValue: 0,
      l:'',
      d:'',
      if: 'blur_effect_show',
      unit: units.pixel
    }),

    offsetY: builder.number('blur_effect_offsetY', {
      defaultValue: 0,
      l:'',
      d:'',
      if: 'blur_effect_show',
      unit: units.pixel
    })
  })
};
